import React from 'react';
import { TableHead, TableRow } from '@/components/ui/table';
import { botUniqueUrlsColumns, type BotUniqueUrlsSemantics } from './botUniqueUrlsLabel';

/**
 * Header row of the bot crawl statistics table. Extracted so the qualification of the unique-URL
 * count and the requests-per-URL ratio can be rendering-tested on its own (PR #5924): the text
 * comes from `semantics.bot_unique_urls` on the analytics response, see botUniqueUrlsLabel.ts.
 */
export function BotCrawlTableHeaderRow({ semantics }: { semantics: BotUniqueUrlsSemantics | undefined }) {
  const c = botUniqueUrlsColumns(semantics);
  return (
    <TableRow>
      <TableHead>Bot</TableHead>
      <TableHead className="text-right">Total Requests</TableHead>
      <TableHead className="text-right" title={c.title}>{c.header}</TableHead>
      <TableHead className="text-right" title={c.ratioTitle}>{c.ratioHeader}</TableHead>
      <TableHead className="text-right">Bandwidth</TableHead>
      <TableHead className="text-right">Avg Size</TableHead>
    </TableRow>
  );
}
